// Initialize Firebase
import firebase from "firebase/app"
import "firebase/auth"

import config from './config'
import store from './store'
import api from './helpers/ApiHelper'

// initialise firebase
firebase.initializeApp(config.firebase)

// authentification
function authStart() {
    store.commit("setAuthLoading", true);
    var provider = new firebase.auth.GoogleAuthProvider();
    firebase
        .auth()
        .signInWithRedirect(provider)
        .then(function () {
            return firebase.auth().getRedirectResult();
        })
        .then(function (result) {
            store.commit("setAccessToken", result.credential.accessToken);
        })
        .catch(function (error) {
            console.error(error.code, error.message);
        })
        .finally(() => {
            store.commit("setAuthLoading", false);
        });
}

// check si authentification
function checkAuth() {
    store.commit('setAuthLoading', true)
    firebase
        .auth()
        .getRedirectResult()
        .then(function (result) {
            if (result.credential) {
                // loginAccessToken(result.credential.accessToken)
                return _loginIdTokenLoad()
            }
        })
        .catch(function (error) {
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;

            console.error(errorCode, errorMessage);
        })
        .finally(() => {
            store.commit('setAuthLoading', false)
        });
}

// login depuis l'access token oAuth
function _loginAccessToken(accessToken) {
    // login backend à partir de l'idToken
    api.post("/auth/login_access_token", { accessToken: accessToken })
        .then(res => {
            if (res.data.jwt) {
                store.dispatch("login", res.data.jwt);
            }
        })
}

// login depuis id token jwt
function _loginIdToken(idToken) {
    // login backend à partir de l'idToken
    api.post("/auth/login_id_token", { idToken: idToken })
        .then(res => {
            if (res.data.jwt) {
                store.dispatch("login", res.data.jwt);
            }
        })
}

// login depuis id token jwt (charge l'id token)
function _loginIdTokenLoad() {

    return firebase
        .auth()
        .currentUser.getIdToken(/* forceRefresh */ false)
        .then(function (idToken) {
            // login backend à partir de l'idToken
            return api.post('/auth/firebase_login_id_token', { idToken: idToken });
        })
        .then(res => {
            if (res.data.jwt) {
                // enregistrement du jwt
                store.commit('setJwt', res.data.jwt);
            }
        })

}

// module
export default {
    authStart: authStart,
    checkAuth: checkAuth
};